import {useSelector} from "react-redux";
import {dashboardStore} from "../store/dashboardPageStore";

export interface IDashboardUserTotalPointsLogic {
  totalPoints?: string;
}

export const useDashboardUserTotalPointsLogic = (): IDashboardUserTotalPointsLogic => {
  const totalPoints = useSelector(() => dashboardStore.getUserSummary().totalPoints);
  return {
    totalPoints,
  };
}
